/* eslint-disable tree-shaking/no-side-effects-in-initialization */
import { RudderAnalytics } from "@rudderstack/analytics-js";
export const RUDDER_ANALYTICS: RudderAnalytics = new RudderAnalytics();
